import styled, { css } from "styled-components";





const TimerWrapper = styled.div`
  textarea:focus,
  input:focus {
    outline: none;
  }
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type="number"] {
    -moz-appearance: textfield;
  }


  .timeHeader{
    display: flex;
    align-items: center;
    gap: 12px;


    .iconContainer{
     display: flex;
     width: 40px;
     height: 40px;
     flex-direction: column;
     justify-content: center;
     align-items: center;
     gap: 10px;
     flex-shrink: 0;
     border-radius: 40px;
     background:  #184A61;
    }
    .headingText{
     color: var(--Font-Color-on-Light-theme-500, #184A61);
     font-family: Lato;
     font-size: 14px;
     font-style: normal;
     font-weight: 400;
     line-height: 20px; 
    }
  }

  .noteText{
    color: var(--Error-500, #DA6C74);
    font-family: Lato;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px; 
  }
`;



const TimerHead = styled.div`
  font-family: "Lato";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 20px;
  text-align: center;
  color: #0D4270;
`;


const MilesPicker = styled.div`
 padding: 16px 0px;
 display: flex;
 justify-content: center;
 gap: 20px;

 .dotMiles {
    display:flex;
    justify-content:center;
    align-items:center;
    font-family: Lato;
    font-style: normal;
    font-weight: 500;
    font-size: 48px;
    line-height: 24px;
    position: relative;
    color:#184A61
    ${'' /* top: 65px; */}
    ${'' /* left: 18px; */}
  }
`;



const TimerPicker = styled.div`
  padding: 16px 0px;
  display: flex;
`;

const TimerButton = styled.div`
  padding: 5px 30px;
  margin-top: 10px;
  cursor: pointer;
  position: relative;
  z-index: 1000;
  > div {
    align-items: center;
    display: flex;
    justify-content: center;
    background: #fd7175;
    border-radius: 6px;
    font-family: Lato;
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 16px;
    text-align: center;
    color: #ffffff;
    height: 50px;
  }
  
`;



const TimerSemi = styled.div`
  width: 5%;
  > div:first-child {
    height: 25%;
  }
  > div:nth-child(2) {
    height: 75%;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .topdotMiles{
    display:flex;
    justify-content:center;
    align-items:center;
    font-family: Lato;
    font-style: normal;
    font-weight: 500;
    font-size: 48px;
    line-height: 24px;
    position: relative;
    top:93px;
    color:#184A61
  }

  .dotMiles{
    display:flex;
    justify-content:center;
    align-items:center;
    font-family: Lato;
    font-style: normal;
    font-weight: 500;
    font-size: 48px;
    line-height: 24px;
    position: relative;
    top:88px;
    color:#184A61
  }
`;

const TimerSection = styled.div`
  text-align: center;
  .hourMinuteText {
    font-family: Lato;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 24px;
    font-weight: 700;
    text-align: center;
    color: #184A61;
    margin-bottom: 16px;
  }
  .picker {
    flex-direction: column;
    background: #FEFEFE;
    border:1px solid #DCDCDC;
    border-radius: 4px;
    height: 158px;
    width: 158px;
    display: flex;
    justify-content: center;
    align-items: center;

    .time{
        height:78px;
        width:75px;
        color: var(--Font-Color-on-Light-theme-500, #184A61);
        font-family: Lato;
        font-size: 64px;
        font-style: normal;
        font-weight: 700;
        line-height: 78px;

        .numberText{
             padding:0px !important;
             height:78px;
             width:78px;
             width:inherit;
             border:none;
             text-Align:center;
             color: var(--Font-Color-on-Light-theme-500, #184A61);
        }
    }

    .upArrowContainer{
        cursor: pointer;
    }
    .downArrowContainer{
        cursor: pointer;
        transform: rotate(180deg);
    }
  }
`;




const MilesImg = styled.div`
  text-align: center;
  > img {
    width: 122px;
  }
`;

const MilesContent = styled.div`
  margin: 10px 0;
  font-family: "Lato";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 20px;
  text-align: center;
  color: #0D4270;
`;

const MilesHead = styled.div`
  margin: 15px 0;
  font-family: "Lato";
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 17px;
  text-align: center;
  color: #3a3a3a;
`;

// const MilesPicker = styled.div`
//   margin: 15px 0;
//   display: flex;
//   .dotMiles {
//     font-family: Rubik;
//     font-style: normal;
//     font-weight: 500;
//     font-size: 48px;
//     line-height: 24px;
//     position: relative;
//     top: 65px;
//     left: 18px;
//   }
//   > div:first-child {
//     width: 20%;
//   }
//   > div:nth-child(2) {
//     width: 25%;
//     display: flex;
//     flex-direction: column;
//     height: 100px;
//     background: #eaeaea;
//     border-radius: 3px;
//     font-family: Rubik;
//     font-style: normal;
//     font-weight: normal;
//     font-size: 64px;
//     line-height: 17px;
//     text-align: center;
//     color: #3a3a3a;
//     display: flex;
//     justify-content: center;
//     align-items: center;
//   }
//   > div:nth-child(3) {
//     width: 10%;
//   }

//   > div:nth-child(4) {
//     display: flex;
//     flex-direction: column;
//     width: 25%;
//     height: 100px;
//     background: #eaeaea;
//     border-radius: 3px;
//     font-family: Rubik;
//     font-style: normal;
//     font-weight: normal;
//     font-size: 64px;
//     line-height: 17px;
//     text-align: center;
//     color: #3a3a3a;
//     display: flex;
//     justify-content: center;
//     align-items: center;
//   }
//   > div:nth-child(5) {
//     width: 20%;
//   }
// `;



const MilesSecond = styled.div`
  > div:first-child {
    width: 100%;
    height: 20%;
    cursor: pointer;
    position: relative;
    z-index: 100;
  }
  > div:nth-child(2) {
    height: 60%;
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
  }
  > div:last-child {
    width: 100%;
    height: 20%;
    cursor: pointer;
    position: relative;
    z-index: 100;
  }
`;


const IntensityWrapper = styled.div`
.timeHeader{
    display: flex;
    align-items: center;
    gap: 12px;

    .iconContainer{
     display: flex;
     width: 40px;
     height: 40px;
     flex-direction: column;
     justify-content: center;
     align-items: center;
     gap: 10px;
     flex-shrink: 0;
     border-radius: 40px;
     background:  #184A61;
    }
    .headingText{
     color: var(--Font-Color-on-Light-theme-500, #184A61);
     font-family: Lato;
     font-size: 14px;
     font-style: normal;
     font-weight: 400;
     line-height: 20px; 
    }
  }

  .buttonContainer{
      display: flex;
      gap:16px;
      justify-content: center;
    }
    .workoutText{
     color: var(--Font-Color-on-Light-theme-500, #184A61);
     font-family: Lato;
     font-size: 14px;
     font-style: normal;
     font-weight: 400;
     line-height: 20px;
    }

`;


const IntensityNameContainer = styled.div`
display:flex;
gap:8px;
margin:16px 12px 0px 12px;

.selectedIntensity{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width:100px;
  height:52px;
  padding:4px 0px; 
  gap:4px;
  cursor:pointer;
  border-radius:4px;

  .imageBox{
    height: 24px;
    width: 24px;
  }
  .intensityText{
    color: var(--Font-Color-on-Light-theme-500, #184A61);
    text-align: center;
    font-family: Lato;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px; /* 133.333% */
  }
}



`;





const CalendarContainer = styled.div`
  ${'' /* width: 100%; */}
  padding:20px;
  width: 428px;
  height: 340px;
  background-color: #F8F8F8;
  border-radius: 12px;
  @media (min-width: 1550px) {
    width: 100%;
  }
  @media (max-width: 1450px) and (min-width: 1300px) {
    width: 100%;
  }
  @media (max-width: 1250px) {
    width: 100%;
  }
  .react-calendar {
    width: 100%;
    height: 100%;
    justify-content: flex-start;


       .react-calendar__year-view__months__month {
     color: #184A61 !important;
     font-weight: 600 !important;
     font-family: Lato !important;
     background: transparent !important;
     -webkit-text-fill-color: #184A61 !important;
   }


   .react-calendar__navigation button:disabled {
  background-color: transparent !important;
  cursor: not-allowed !important;

  svg, path, circle {
    ${'' /* opacity: 0.3 !important; */}
    /* If you want to change the color to gray when disabled: */
     fill: #DCDCDC !important; 
  }
}

       .react-calendar__tile:disabled {
         background-color: #f0f0f0 !important; /* Light gray background */
         cursor: not-allowed !important;
       }
       
       .react-calendar__tile:disabled abbr {
         color: #ccc !important; /* Light gray text */
         opacity: 0.6;
       }
   
   /* CURRENT MONTH tile */
   .react-calendar__year-view__months__month.react-calendar__tile--now {
     color: #184A61 !important;
     font-weight: 700 !important;
     font-family: Lato !important;
     background: transparent !important;
     ${'' /* -webkit-text-fill-color: #DA6C74 !important; */}
   }

      .react-calendar__decade-view__years__year {
     -webkit-text-fill-color: #184A61 !important;
     color: #DA6C74 !important;
     background: transparent !important;
   }
   
   /* DECADE tiles inside CENTURY view */
   .react-calendar__century-view__decades__decade {
     -webkit-text-fill-color: #184A61 !important;
     color: #DA6C74 !important;
     background: transparent !important;
   }

   
    .react-calendar__tile--disabled {
      cursor: not-allowed !important;
      opacity: 0.5 !important;
      pointer-events: none !important;
    }
  
    ${'' /* .react-calendar__month-view__days__day--neighboringMonth {
      cursor: not-allowed !important;
      opacity: 0.4;
      pointer-events: none !important;
    } */}

    .react-calendar__month-view__days__day--neighboringMonth {
     visibility: hidden !important; /* This hides the content but keeps the space */
     pointer-events: none !important; /* Ensures they aren't clickable */
     background: transparent !important; /* Removes the white box background */
    border: none !important;
    box-shadow: none !important;
   }

    

   

    .react-calendar__navigation {
      display: flex;
      padding: 10px 80px;
      margin-bottom:16px;
      height: 15%;
      align-items: center;
      justify-content: space-between;



      .react-calendar__tile--disabled {
        cursor: not-allowed !important;
        opacity: 0.5; /* optional */
      }
      
      /* For neighboring month tiles (previous/next month dates) */
      .react-calendar__month-view__days__day--neighboringMonth {
        cursor: not-allowed !important;
      }
      


     

      button.react-calendar__navigation__prev-button,
      button.react-calendar__navigation__next-button {
        border: none;
        ${'' /* width: 30px; */}
        ${'' /* height: 30px; */}
        ${'' /* border-radius: 50%; */}
        ${'' /* background-color: #DA6C74; */}
        color: #DA6C74;
        font-size: 25px;
        background:none;
      }
       /* Enabled arrows */
      

      button.react-calendar__navigation__prev2-button,
      button.react-calendar__navigation__next2-button {
        display: none; /* These arrows are hidden by props already */
      }
      .react-calendar__navigation__label {
        border: none;
        background:transparent;
        width: 140px;
        min-height: 24px;
        color:#184A61;

        &:focus {
          outline: none;
        }
        span.react-calendar__navigation__label__labelText.react-calendar__navigation__label__labelText--from {
          font-size: 18px;
          font-family: "Lato";
          background: -webkit-linear-gradient(
            90deg,
            #006fbc -1.11%,
            #7f43ff 97.46%
          );
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
      }
    }

    


    .react-calendar__navigation__label span.react-calendar__navigation__label__labelText.react-calendar__navigation__label__labelText--from {
         background: none !important;
         -webkit-background-clip: initial !important;
         -webkit-text-fill-color: #184A61 !important;
         color: #184A61 !important;
         font-weight: 700 !important;
         line-height: 24px !important;
       }

      .custom-calendar .react-calendar__navigation__label {
        padding: 0 !important;
        margin: 0 !important;
        flex-grow: 0 !important;     /* prevents stretching */
      }
      
      /* Set the gap between arrow → month → arrow */
      .custom-calendar .react-calendar__navigation {
        gap: 20px !important;       
        justify-content: center;     /* keep everything centered */
      }
      
      /* Remove padding on navigation container too */
      .custom-calendar .react-calendar__navigation button {
        padding: 0 !important;
      }

    .react-calendar__viewContainer {
      width: 100%;
      height: 85%;

      @media (max-width: 1250px) {
        padding: 0px;
      }

      .react-calendar__month-view {
        width: 100%;
        height: 100%;
        background-color: #F8F8F8;

        .react-calendar__month-view__weekdays abbr {
      text-decoration: none;
      cursor: default;
      pointer-events: none;
}


        .react-calendar__month-view__weekdays {
          margin-bottom:14px;
          .react-calendar__tile.react-calendar__tile--active.react-calendar__month-view__weekdays__weekday {
            border-bottom: 4px solid #000;
          }
          .react-calendar__month-view__weekdays__weekday {
            width:48px;
            height:28px;
            margin:2px;
            padding-bottom: 10px;
            ${"" /* border-bottom: 4px solid #AFAFAF; */}
            text-align: center;
            abbr[title] {
              border-bottom: none;
              text-decoration: none;
              color: #184A61;
            }
          }
        }
        .react-calendar__month-view__days {
          margin-top: 8px;
          justify-content: space-evenly;
          background-color:  #F8F8F8;
          height: 100%;
          width: 100%;

          display: grid !important;
          grid-template-columns: repeat(7, 1fr) !important;
          gap: 8px;

          .react-calendar__tile--disabled::after,
          .react-calendar__month-view__days__day--neighboringMonth::after {
            position: absolute;
            top: 4px;
            right: 4px;
            font-size: 14px;
          }
       
       
          .react-calendar__month-view__days__day--neighboringMonth {
            opacity: 0.5 !important;
            cursor: not-allowed !important;
            pointer-events: none !important;
          }
              
          .react-calendar__month-view__days__day--neighboringMonth abbr {
          color: #184A61 !important;
          font-weight: 600;
}
          
          .react-calendar__tile {
           width: 100%;
           height: 54px;
           border-radius: 3px;
           border: none;
           background: #FEFEFE;
         
           > abbr {
             font-size: 16px;
             color: #184A61;
             font-family: "Lato";
           }
         
           &:focus {
             outline: none;
           }
         }
         
         /* Optional: style the inactive (neighboringMonth) dates differently */
         .react-calendar__month-view__days__day--neighboringMonth {
           opacity: 0.4;
         }


          button.react-calendar__tile.react-calendar__tile--now.react-calendar__tile--active.react-calendar__tile--range.react-calendar__tile--rangeStart.react-calendar__tile--rangeEnd.react-calendar__tile--rangeBothEnds.react-calendar__month-view__days__day,
          button.react-calendar__tile.react-calendar__tile--active.react-calendar__tile--range.react-calendar__tile--rangeStart.react-calendar__tile--rangeEnd.react-calendar__tile--rangeBothEnds.react-calendar__month-view__days__day {
            background: #DA6C74;
            flex-basis: unset !important;
            max-width: unset !important;
            overflow: unset !important;
            border: none;
            border-radius: 3px;
            width: 48px;
            height: 28px;
            margin: 3px 0;
            &:focus {
              outline: none;
            }

            > abbr {
              font-size: 13px;
              line-height: 19px;
              color: #fff;
              text-align: center;
              font-family: Lato;
              font-size: 18px;
            }

            @media (min-width: 1550px) {
              margin: 3px 0;
            }
            @media (max-width: 1450px) and (min-width: 1300px) {
              margin: 5px 0;
            }
            @media (max-width: 1250px) {
              min-height: 33px;
              width: 33px;
              margin: 14px;
            }
            @media (max-width: 1223px) {
              margin: 13px;
            }
            @media (max-width: 1195px) {
              margin: 12px;
            }
            @media (max-width: 1167px) {
              margin: 11px;
            }
            @media (max-width: 1059px) {
              margin: 10px;
            }
            @media (max-width: 1046px) {
              margin: 9px;
            }
            @media (max-width: 1003px) {
              margin: 8px;
            }
            @media (max-width: 975px) {
              margin: 7px;
            }
            @media (max-width: 950px) {
              margin: 15px;
            }
            @media (max-width: 931px) {
              margin: 14px;
            }
            @media (max-width: 903px) {
              margin: 13px;
            }
            @media (max-width: 875px) {
              margin: 12px;
            }
            @media (max-width: 847px) {
              margin: 11px;
            }
            @media (max-width: 819px) {
              margin: 10px;
            }
            @media (max-width: 791px) {
              margin: 9px;
            }
            @media (max-width: 763px) {
              margin: 8px;
            }
            @media (max-width: 735px) {
              margin: 7px;
            }
            @media (max-width: 707px) {
              margin: 6px;
            }
            @media (max-width: 688px) {
              margin: 28px;
            }
            @media (max-width: 642px) {
              margin: 27px;
            }
            @media (max-width: 628px) {
              margin: 25px;
            }
            @media (max-width: 600px) {
              margin: 24px;
            }
            @media (max-width: 586px) {
              margin: 23px;
            }
            @media (max-width: 572px) {
              margin: 22px;
            }
            @media (max-width: 559px) {
              margin: 21px;
            }
            @media (max-width: 544px) {
              margin: 20px;
            }
            @media (max-width: 530px) {
              margin: 19px;
            }
            @media (max-width: 516px) {
              margin: 18px;
            }
            @media (max-width: 502px) {
              margin: 17px;
            }
            @media (max-width: 488px) {
              margin: 16px;
            }
            @media (max-width: 474px) {
              margin: 15px;
            }
            @media (max-width: 460px) {
              margin: 14px;
            }
            @media (max-width: 446px) {
              margin: 13px;
            }
            @media (max-width: 432px) {
              margin: 12px;
            }
            @media (max-width: 418px) {
              margin: 11px;
            }
            @media (max-width: 404px) {
              margin: 10px;
            }
            @media (max-width: 390px) {
              margin: 9px;
            }
            @media (max-width: 376px) {
              margin: 8px;
            }
            @media (max-width: 362px) {
              margin: 7px;
            }
            @media (max-width: 348px) {
              margin: 6px;
            }
            @media (max-width: 334px) {
              margin: 5px;
            }
            @media (max-width: 320px) {
              margin: 4px;
            }
          }
          ${({ bgColor }) =>
    bgColor && css`
              button.react-calendar__tile.react-calendar__tile--active {
                background: linear-gradient(
                  90deg,
                  #006fbc -1.11%,
                  #7f43ff 97.46%
                ) !important;
                color: white !important;
                border: none !important;

                > abbr {
                  font-size: 13px !important;
                  line-height: 19px;
                  color: #fff !important;
                  text-align: center;
                  font-family: Lato;
                }
              }
            `}

          button.react-calendar__tile.react-calendar__month-view__days__day.react-calendar__month-view__days__day--weekend {
            background-color: white;
            flex-basis: unset !important;
            max-width: unset !important;
            overflow: unset !important;
            width: 48px;
            height: 28px;
            border: none;
            background: #FEFEFE;
            border-radius: 3px;
            margin: 3px 0;
            > abbr {
              font-family: "Lato";
              font-style: normal;
              font-weight: normal;
              font-size: 16px;
              line-height: 20px;
              text-align: center;
              color: #184A61;
            }
          }

          button.react-calendar__tile.react-calendar__month-view__days__day.react-calendar__month-view__days__day--neighboringMonth {
            margin: 0;
            background: none !important;
            border: none !important;
            color: #184A61 !important;        /* Set font color */
            opacity: 1 !important;     

            .react-calendar__month-view__days__day--neighboringMonth > abbr {
              display: block; /* show the day */
              color: #184A61 !important; /* optional: gray out */
              font-weight: 600;
            }

            ${'' /* > abbr {
              display: none;
            } */}

            &:focus {
              outline: none;
            }

            @media (min-width: 1550px) {
              margin: 3px 0;
            }
            @media (max-width: 1450px) and (min-width: 1300px) {
              margin: 5px 0;
            }
            @media (max-width: 1250px) {
              min-height: 33px;
              width: 33px;
              margin: 14px;
            }
            @media (max-width: 1223px) {
              margin: 13px;
            }
            @media (max-width: 1195px) {
              margin: 12px;
            }
            @media (max-width: 1167px) {
              margin: 11px;
            }
            @media (max-width: 1059px) {
              margin: 10px;
            }
            @media (max-width: 1046px) {
              margin: 9px;
            }
            @media (max-width: 1003px) {
              margin: 8px;
            }
            @media (max-width: 975px) {
              margin: 7px;
            }
            @media (max-width: 950px) {
              margin: 15px;
            }
            @media (max-width: 931px) {
              margin: 14px;
            }
            @media (max-width: 903px) {
              margin: 13px;
            }
            @media (max-width: 875px) {
              margin: 12px;
            }
            @media (max-width: 847px) {
              margin: 11px;
            }
            @media (max-width: 819px) {
              margin: 10px;
            }
            @media (max-width: 791px) {
              margin: 9px;
            }
            @media (max-width: 763px) {
              margin: 8px;
            }
            @media (max-width: 735px) {
              margin: 7px;
            }
            @media (max-width: 707px) {
              margin: 6px;
            }
            @media (max-width: 688px) {
              margin: 28px;
            }
            @media (max-width: 642px) {
              margin: 27px;
            }
            @media (max-width: 628px) {
              margin: 25px;
            }
            @media (max-width: 600px) {
              margin: 24px;
            }
            @media (max-width: 586px) {
              margin: 23px;
            }
            @media (max-width: 572px) {
              margin: 22px;
            }
            @media (max-width: 559px) {
              margin: 21px;
            }
            @media (max-width: 544px) {
              margin: 20px;
            }
            @media (max-width: 530px) {
              margin: 19px;
            }
            @media (max-width: 516px) {
              margin: 18px;
            }
            @media (max-width: 502px) {
              margin: 17px;
            }
            @media (max-width: 488px) {
              margin: 16px;
            }
            @media (max-width: 474px) {
              margin: 15px;
            }
            @media (max-width: 460px) {
              margin: 14px;
            }
            @media (max-width: 446px) {
              margin: 13px;
            }
            @media (max-width: 432px) {
              margin: 12px;
            }
            @media (max-width: 418px) {
              margin: 11px;
            }
            @media (max-width: 404px) {
              margin: 10px;
            }
            @media (max-width: 390px) {
              margin: 9px;
            }
            @media (max-width: 376px) {
              margin: 8px;
            }
            @media (max-width: 362px) {
              margin: 7px;
            }
            @media (max-width: 348px) {
              margin: 6px;
            }
            @media (max-width: 334px) {
              margin: 5px;
            }
            @media (max-width: 320px) {
              margin: 4px;
            }
          }

          button.react-calendar__tile.react-calendar__month-view__days__day {
            background-color: white;
            flex-basis: unset !important;
            max-width: unset !important;
            overflow: unset !important;
            width: 48px;
            height: 28px;
            border: none;
            background: #FEFEFE;
            border-radius: 3px;
            margin: 3px;
            > abbr {
              font-family: "Lato";
              font-style: normal;
              font-weight: normal;
              font-size: 16px;
              line-height: 16px;
              text-align: center;
              color: #184A61;
            }

            &:focus {
              outline: none;
            }

            @media (min-width: 1550px) {
              margin: 3px 0;
            }
            @media (max-width: 1450px) and (min-width: 1300px) {
              margin: 5px 0;
            }
            @media (max-width: 1250px) {
              min-height: 33px;
              width: 33px;
              margin: 14px;
            }
            @media (max-width: 1223px) {
              margin: 13px;
            }
            @media (max-width: 1195px) {
              margin: 12px;
            }
            @media (max-width: 1167px) {
              margin: 11px;
            }
            @media (max-width: 1059px) {
              margin: 10px;
            }
            @media (max-width: 1046px) {
              margin: 9px;
            }
            @media (max-width: 1003px) {
              margin: 8px;
            }
            @media (max-width: 975px) {
              margin: 7px;
            }
            @media (max-width: 950px) {
              margin: 15px;
            }
            @media (max-width: 931px) {
              margin: 14px;
            }
            @media (max-width: 903px) {
              margin: 13px;
            }
            @media (max-width: 875px) {
              margin: 12px;
            }
            @media (max-width: 847px) {
              margin: 11px;
            }
            @media (max-width: 819px) {
              margin: 10px;
            }
            @media (max-width: 791px) {
              margin: 9px;
            }
            @media (max-width: 763px) {
              margin: 8px;
            }
            @media (max-width: 735px) {
              margin: 7px;
            }
            @media (max-width: 707px) {
              margin: 6px;
            }
            @media (max-width: 688px) {
              margin: 28px;
            }
            @media (max-width: 642px) {
              margin: 27px;
            }
            @media (max-width: 628px) {
              margin: 25px;
            }
            @media (max-width: 600px) {
              margin: 24px;
            }
            @media (max-width: 586px) {
              margin: 23px;
            }
            @media (max-width: 572px) {
              margin: 22px;
            }
            @media (max-width: 559px) {
              margin: 21px;
            }
            @media (max-width: 544px) {
              margin: 20px;
            }
            @media (max-width: 530px) {
              margin: 19px;
            }
            @media (max-width: 516px) {
              margin: 18px;
            }
            @media (max-width: 502px) {
              margin: 17px;
            }
            @media (max-width: 488px) {
              margin: 16px;
            }
            @media (max-width: 474px) {
              margin: 15px;
            }
            @media (max-width: 460px) {
              margin: 14px;
            }
            @media (max-width: 446px) {
              margin: 13px;
            }
            @media (max-width: 432px) {
              margin: 12px;
            }
            @media (max-width: 418px) {
              margin: 11px;
            }
            @media (max-width: 404px) {
              margin: 10px;
            }
            @media (max-width: 390px) {
              margin: 9px;
            }
            @media (max-width: 376px) {
              margin: 8px;
            }
            @media (max-width: 362px) {
              margin: 7px;
            }
            @media (max-width: 348px) {
              margin: 6px;
            }
            @media (max-width: 334px) {
              margin: 5px;
            }
            @media (max-width: 320px) {
              margin: 4px;
            }
          }
        }
      }
      .react-calendar__year-view {
        width: 100%;
        height: 100%;

        .react-calendar__year-view__months {
          height: 100%;
          width: 100%;
          justify-content: space-evenly;

          button.react-calendar__tile.react-calendar__tile--now.react-calendar__tile--hasActive.react-calendar__year-view__months__month {
            border: none;
            background-color: #fff;
            font-size: 16px;
            font-family: "Lato";
            background: -webkit-linear-gradient(
              90deg,
              #006fbc -1.11%,
              #7f43ff 97.46%
            );
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;

            &:focus {
              outline: none;
            }
          }

          button.react-calendar__tile.react-calendar__year-view__months__month {
            border: none;
            background-color: #fff;
            color: #000000;
            font-size: 16px;
            font-family: "Lato";

            &:focus {
              outline: none;
            }
          }
        }
      }
      .react-calendar__decade-view {
        width: 100%;
        height: 100%;

        .react-calendar__decade-view__years {
          width: 100%;
          height: 100%;

          button.react-calendar__tile.react-calendar__tile--now.react-calendar__tile--hasActive.react-calendar__decade-view__years__year {
            border: none;
            background-color: #fff;
            font-size: 16px;
            font-family: "Lato";
            background: -webkit-linear-gradient(
              90deg,
              #006fbc -1.11%,
              #7f43ff 97.46%
            );
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;

            &:focus {
              outline: none;
            }
          }

          button.react-calendar__tile.react-calendar__decade-view__years__year {
            border: none;
            background-color: #fff;
            color: #000000;
            font-size: 16px;
            font-family: "Lato";

            &:focus {
              outline: none;
            }
          }
        }
      }
      .react-calendar__century-view {
        height: 100%;
        width: 100%;

        .react-calendar__century-view__decades {
          height: 100%;
          width: 100%;

          button.react-calendar__tile.react-calendar__tile--now.react-calendar__tile--hasActive.react-calendar__century-view__decades__decade {
            border: none;
            background-color: #fff;
            font-size: 16px;
            font-family: "Lato";
            background: -webkit-linear-gradient(
              90deg,
              #006fbc -1.11%,
              #7f43ff 97.46%
            );
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;

            &:focus {
              outline: none;
            }
          }

          button.react-calendar__tile.react-calendar__century-view__decades__decade {
            border: none;
            background-color: #fff;
            color: #000000;
            font-size: 16px;
            font-family: "Lato";

            &:focus {
              outline: none;
            }
          }
        }
      }
    }
  }
`;



export {TimerWrapper, TimerHead, TimerPicker, TimerSemi, TimerSection,  TimerButton, MilesImg, MilesContent, MilesHead,MilesSecond,MilesPicker,IntensityWrapper,IntensityNameContainer,CalendarContainer};